import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Rooms from "@/pages/Rooms";
import Location from "@/pages/Location";
import Gallery from "@/pages/Gallery";
import Dining from "@/pages/Dining";
import Medjugorje from "@/pages/Medjugorje";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <Header />
          <main className="pb-16 lg:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sobe" element={<Rooms />} />
              <Route path="/rooms" element={<Navigate to="/sobe" replace />} />
              <Route path="/lokacija" element={<Location />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/dining" element={<Dining />} />
              <Route path="/blagovaonica" element={<Navigate to="/dining" replace />} />
              <Route path="/medjugorje" element={<Medjugorje />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <MobileCTA />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
